import * as angular from "angular";

const expensesTableColumnsMap = {

  billImage: {enabled: true, order: 1, permission: undefined},
  serviceLocation: {enabled: true, order: 2, permission: undefined},
  createdBy: {enabled: true, order: 3, permission: undefined},
  createdAt: {enabled: true, order: 4, permission: undefined},
  description: {enabled: true, order: 5, permission: undefined},

}


angular
  .module('bringoz.admin.expenses')
  .constant('expensesConstants', {
    expensesTableColumnsMap: expensesTableColumnsMap,
  });

